import { render, staticRenderFns } from "./curso-final.vue?vue&type=template&id=6dc6cd30&scoped=true&"
import script from "./curso-final.vue?vue&type=script&lang=ts&"
export * from "./curso-final.vue?vue&type=script&lang=ts&"
import style0 from "./curso-final.vue?vue&type=style&index=0&id=6dc6cd30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc6cd30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VProgressCircular,VRow})
